module.exports = __webpack_public_path__ + "static/media/footer-messages.de51ed85.png";